import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isQuizMultiChoice(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.QUIZ_MULTI_CHOICE && typeof label === 'string' && Array.isArray(value) && value.every(item => typeof item === 'string');
}
function _formatQuizMultiChoice(_ref) {
  let {
    field,
    value
  } = _ref;
  if (value.length === 0) {
    return undefined;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatQuizMultiChoice(submission) {
  if (isQuizMultiChoice(submission)) {
    return _formatQuizMultiChoice(submission);
  }
  return undefined;
}
//# sourceMappingURL=quiz-multi-choice-preview.js.map